module.exports = __webpack_public_path__ + "assets/img/group_1_2.6905ccaf.png";